import { useExactMatchedRoute } from 'common/hooks/routeHookHelpers';
import featureFlags from '../../helpers/featureFlags';

const disabledVersioningPages = [
  '/projects/:projectId',
  'analyses/quality-of-earnings',
  'analyses/quality-of-earnings/edit',
  'analyses/net-working-capital',
  'analyses/net-working-capital/edit',
  'analyses/debt-debt-like',
  'analyses/debt-debt-like/edit',
];

export const useShouldDisplayVersioningIcon = () => {
  const matchedRoute = useExactMatchedRoute();
  const { path = '' } = matchedRoute || {};
  return (
    featureFlags.isVersioningPhase1Enabled &&
    !disabledVersioningPages.some((page) => path.endsWith(page))
  );
};
